/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PopupPicker from "vux/src/components/popup-picker/index.vue";
import { mapState } from 'vuex';
import { updateUserStateTag, epTagList } from '@/api';
export default {
  name: 'Popup',
  props: {
    Types: {
      type: Number,
      required: true
    },
    statuscolor: {
      type: String,
      default: '#5ed298'
    }
  },
  components: {
    PopupPicker: PopupPicker
  },
  data: function data() {
    return {
      minePopup: false,
      // 我的页面弹出
      userInfoPopup: false,
      // 个人信息弹出
      noPopup: false,
      // 不弹出弹框
      micronoPopup: false,
      // 小状态
      reveal: false,
      //
      val: [],
      epTagList: [],
      tagId: Number
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['user'])),
  methods: {
    // 切换修改工作状态
    onChange: function onChange(val) {
      var _this = this;

      for (var i = 0; i < val.length; i++) {
        this.tagId = val[i];
      }

      if (!this.tagId || this.tagId === 'undefined') return;
      var vo = {
        tagId: this.tagId
      };
      updateUserStateTag(vo).then(function (res) {
        if (res.success) {
          _this.$emit('on-success');
        }
      });
    },
    load: function load() {
      var _this2 = this;

      if (this.Types === 1) {
        this.minePopup = true;
      }

      if (this.Types === 2) {
        this.userInfoPopup = true;
      }

      if (this.Types === 3) {
        this.noPopup = true;
      }

      if (this.Types === 4) {
        this.micronoPopup = true;
      } // 工作状态列表


      var data = {
        code: 1
      };

      if (this.Types === 1 || this.Types === 2) {
        epTagList(data).then(function (res) {
          if (res.success) {
            for (var i = 0; i < res.data.length; i++) {
              var list = res.data[i];

              _this2.epTagList.push({
                name: list.name,
                value: list.id + ''
              });
            }
          }
        });
      }
    },
    PopupPicker: function PopupPicker() {
      if (this.user.isChargeUser === 0) {
        this.$vux.toast.text('免费版本不支持设置人员状态操作，建议升级为VIP版本，客服热线0592-3278627');
        return false;
      } else {
        this.reveal = true;
      }
    }
  },
  created: function created() {
    this.load();
  }
};